import api from "./api";

const notificationPushService = {
  webConfig: () => api.get("/notifications/firebase-web-config", { skipAuthExpire: true }),
  registerDeviceToken: (payload) => api.post("/notifications/device-token", payload),
  removeDeviceToken: (token) => api.delete("/notifications/device-token", { data: { token } }),
};

export default notificationPushService;
